import PropTypes from 'prop-types';
// @mui
import {useTheme} from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
// hooks
import {useResponsive} from 'packages/common/hooks/useResponsive';
// theme
import {ADMIN_PALETTE} from 'packages/common/theme/admin';
// components
import Iconify from 'packages/common/components/iconify';
import {useSettingsContext} from 'packages/common/components/settings';
//
import {NAV} from '../config-layout';

// ----------------------------------------------------------------------

export default function NavToggleButton({sx, ...other}) {
  const theme = useTheme();

  const settings = useSettingsContext();

  const lgUp = useResponsive('up', 'lg');

  if (!lgUp) {
    return null;
  }

  return (
    <IconButton
      size="small"
      onClick={() =>
        settings.onUpdate('themeLayout', settings.themeLayout === 'vertical' ? 'mini' : 'vertical')
      }
      sx={{
        'p': 0.5,
        'top': 32,
        'position': 'fixed',
        'left': NAV.W_VERTICAL - 12,
        'zIndex': theme.zIndex.appBar + 1,
        'border': `1px solid ${ADMIN_PALETTE.nav.divider}`,
        'bgcolor': ADMIN_PALETTE.nav.backgroundOverlay,
        'color': ADMIN_PALETTE.text.primarySoft,
        'backdropFilter': 'blur(8px)',
        '&:hover': {
          bgcolor: ADMIN_PALETTE.accent.bg15,
          color: ADMIN_PALETTE.accent.light,
          borderColor: ADMIN_PALETTE.accent.bg30,
        },
        ...sx,
      }}
      {...other}
    >
      <Iconify
        width={16}
        icon={
          settings.themeLayout === 'vertical' ?
            'eva:arrow-ios-back-fill' :
            'eva:arrow-ios-forward-fill'
        }
      />
    </IconButton>
  );
}

NavToggleButton.propTypes = {
  sx: PropTypes.object,
};
